import React from "react";

export const AppLogo: React.FC = () => {
  return (
    <img
      src="https://cdn.prod.website-files.com/66ffd2eb652c51f422cc31e8/670407a54344c0c196188cc0_Logo.png"
      alt="Sky Logo"
      className="h-8 w-auto transition-all duration-300"
    />
  );
};
